import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=958165e4&scoped=true&"
import script from "./confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./confirm-dialog.vue?vue&type=script&lang=js&"
import style0 from "./confirm-dialog.vue?vue&type=style&index=0&id=958165e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958165e4",
  null
  
)

export default component.exports